let config = {
  previewMaxWidth: 200,
  previewMaxHeight: 200,
  previewMinWidth: null,
  previewMinHeight: null,
  previewCrop: false,
  googleKey: null,
  dateDisplayFormat: 'll',
  dateTimeDisplayFormat: 'llll',
  dateTimeModelFormat: 'YYYY-MM-DDTHH:mm:ssZZ',
  timeTwelveFormat: true,
};

export default config;
